export const LAST_BUILD_TIME = '2024-06-30T12:50:20.213Z'